export const SET_PROFILE = "setProfile";
export const CLEAR_PROFILE = "clearProfile";
export const SET_FIELD = "setField";
export const SET_EDIT_FIELD = "setEditField";
export const SET_PROFILE_EDIT = "setProfileEdit";
export const CLEAR_PROFILE_EDIT = "clearProfileEdit";
